var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundAccountButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8825 36.1356C44.478 32.4115 46 27.8835 46 23C46 10.2975 35.7025 0 23 0C10.2975 0 0 10.2975 0 23C0 35.7025 10.2975 46 23 46C25.9266 46 28.7256 45.4534 31.3004 44.4567C29.7442 43.1915 28.75 41.2619 28.75 39.1C28.75 35.2892 31.8392 32.2 35.65 32.2C38.3996 32.2 40.7736 33.8083 41.8825 36.1356Z",
    fill: "#479DD4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.6498,
    cy: 39.1,
    r: 4.6,
    fill: "#38B39E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundAccountButton);
export default __webpack_public_path__ + "static/media/backgroundAccountButton.865735ac59c47d7db8c2850f948d6f8d.svg";
export { ForwardRef as ReactComponent };